import { jsx as r } from "react/jsx-runtime";
import _ from "clsx";
import '../../_assets/Label.NglYtYkF.css';const n = "_label_1wh0z_44", i = "_disabled_1wh0z_54", d = "_error_1wh0z_58", b = "_success_1wh0z_62", s = {
  label: n,
  disabled: i,
  error: d,
  success: b,
  "slide-in-out": "_slide-in-out_1wh0z_1",
  "fade-in-out": "_fade-in-out_1wh0z_1"
}, m = (e) => {
  const { variant: l, content: o, className: a, ...t } = e, c = _(s.label, s[l], a);
  return /* @__PURE__ */ r("div", { ...t, className: c, children: o });
};
export {
  m as Label
};
